import React from 'react';
import { USERS } from '../../../config/trainers';

export function AdminIcon({ name, size = 20 }) {
  const paths = {
    statistics: <><path d="M4 20h16M6 16V9M12 16V4M18 16v-5" /></>,
    calendar: <><rect x="3" y="5" width="18" height="16" rx="3" /><path d="M7 3v4M17 3v4M3 11h18M8 15h2M14 15h2" /></>,
    requests: <><rect x="5" y="4" width="14" height="17" rx="3" /><path d="M9 3h6v4H9zM9 12h6M9 16h4" /></>,
    text: <><path d="M4 5h16v12H9l-5 4V5zM8 9h8M8 13h5" /></>,
    arrow: <path d="m9 5 7 7-7 7" />,
    refresh: <><path d="M20 7v5h-5M4 17v-5h5" /><path d="M6 7a7 7 0 0 1 12-1l2 6M4 12l2 6a7 7 0 0 0 12-1" /></>,
    search: <><circle cx="10.5" cy="10.5" r="6.5" /><path d="m16 16 5 5" /></>,
    check: <path d="m5 12 4 4L19 6" />,
    close: <path d="m6 6 12 12M18 6 6 18" />,
    phone: <path d="m7 3 3 5-2 2c2 3 3 4 6 6l2-2 5 3-1 4C11 22 2 13 3 4l4-1z" />,
    logout: <><path d="M10 4H4v16h6M10 12h11m-4-4 4 4-4 4" /></>,
    external: <><path d="M14 3h7v7m0-7L10 14M10 4H4v16h16v-6" /></>,
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{paths[name] || paths.calendar}</svg>;
}

export function TrainerFilter({ activeUser, onChange }) {
  return <div className="ds-trainer-filter" role="group" aria-label="Тренер">
    {[{ id: null, label: 'Усі тренери' }, ...USERS].map(user => <button type="button" key={user.id || 'all'} aria-pressed={(activeUser?.id || null) === user.id} onClick={() => onChange(user.id ? user : null)}>{user.label}</button>)}
  </div>;
}
